import usePages from '@components/ArtBoard/Search/selectors/usePages'
import { selectBlockParent } from '@octopus-do/octopus-project-core'
import * as ActionTypes from '@storeOld/actions'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch, useSelector } from 'react-redux'

import { GlobalActions } from '@/store'
import type { AppState } from '@/types'
import { MODAL_BLOCK_CONTENT_VIEW } from '../../../App/Modal/constants'

export const useOpenContent = (type: 'page' | 'block') => {
  const dispatch = useDispatch()
  const tree = usePages()
  const state = useSelector((state: AppState) => state)
  const openedBlockIdModal = useSelector(({ ui }: AppState) =>
    ui.modalType === MODAL_BLOCK_CONTENT_VIEW ? ui.modalProps.nodeId : null
  )

  return (id: string, options?: { skipScrolling?: boolean }) => {
    // todo: remove nested conditional expressions
    const { skipScrolling } = options || {}
    if (type === 'block') {
      const nodeId = selectBlockParent(id)(state)[0]

      if (!skipScrolling && nodeId) {
        dispatch(
          GlobalActions.jumpTo({
            selector: 'id',
            value: nodeId,
          })
        )
      }

      dispatch({
        type: ActionTypes.OPEN_BLOCK,
        payload: { id },
      })
      return
    }

    if (type === 'page') {
      if (!skipScrolling) {
        GlobalActions.jumpTo({
          selector: 'id',
          value: id,
        })
      }

      if (openedBlockIdModal === id) {
        dispatch(
          notificationActionCreators.setNotification({
            type: NotificationType.LINKED_PAGE_IS_OPEN,
          })
        )
        return
      }

      if (!tree[id]) {
        dispatch(
          notificationActionCreators.setNotification({
            type: NotificationType.PAGE_NOT_FOUND,
          })
        )
        return
      }

      dispatch(
        // @ts-expect-error
        openModal(MODAL_BLOCK_CONTENT_VIEW, { nodeId: id, scrolless: true })
      )
    }
  }
}
